import { useCallback, useEffect } from 'react';

import { useNavigate } from 'react-router';

import { useUserConfig } from '@/features/_shared/user';
import { useMarketsList } from '../../api/marketsList.options';

export const MarketsDefaultRedirect = () => {
  const navigate = useNavigate();

  const { data: marketsListData, isSuccess: isMarketsListSuccess } = useMarketsList();
  const marketsList = marketsListData?.marketsList ?? [];

  const {
    data: userConfigData,
    isSuccess: isUserConfigSuccess,
    isLoading: isUserConfigLoading
  } = useUserConfig();
  const isUserConfigReady = isUserConfigSuccess || (!isUserConfigLoading && !isUserConfigSuccess);
  const defaultMarketId = userConfigData?.defaultMarket?.value;

  const isMarketValid = useCallback(
    (marketId: string) => marketsList.some(m => m.marketId === marketId),
    [marketsList]
  );

  useEffect(() => {
    if (!isMarketsListSuccess || !isUserConfigReady || marketsList.length === 0) return;

    const targetMarketId =
      defaultMarketId && isMarketValid(defaultMarketId)
        ? defaultMarketId
        : marketsList[0]?.marketId;

    if (targetMarketId) {
      navigate(`/markets/${targetMarketId}`, { replace: true });
    }
  }, [
    isMarketsListSuccess,
    isUserConfigReady,
    marketsList,
    defaultMarketId,
    isMarketValid,
    navigate
  ]);

  return null;
};
